import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TreeviewListItem from './item';

function Treeview({
  data,
  selection,
  expanded,
  selectedItems,
  setSelectedItems,
  currentItem,
  setCurrentItem,
  separated,
}) {
  const [openedItems, setOpenedItems] = useState(expanded);

  return (
    <ul className="treeview treeview-select">
      {data.map((treeviewItem) => (
        <TreeviewListItem
          key={treeviewItem.id}
          item={treeviewItem}
          openedItems={openedItems}
          setOpenedItems={setOpenedItems}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          selection={selection}
          currentItem={currentItem}
          setCurrentItem={setCurrentItem}
          separated={separated}
        />
      ))}
    </ul>
  );
}

Treeview.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    expanded: PropTypes.bool,
    name: PropTypes.node.isRequired,
    icon: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    iconClass: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({})),
    faIcon: PropTypes.shape({}),
    disabled: PropTypes.bool,
  })).isRequired,
  selection: PropTypes.bool, // If true selection is enabled
  // Default expanded children ids
  expanded: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  // Selected item ids
  selectedItems: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  setSelectedItems: PropTypes.func, // Setter to select items
  currentItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setCurrentItem: PropTypes.func,
  // Все флажочки не зависмят друг от друга
  separated: PropTypes.bool,
};

Treeview.defaultProps = {
  selection: false,
  expanded: [],
  selectedItems: [],
  setSelectedItems: null,
  currentItem: null,
  setCurrentItem: null,
  separated: false,
};

export default Treeview;
